<template lang="pug">
  form.form(
    :class='classList'
    @submit.prevent='complain'
    @input='resetError'
    novalidate
  )
    .form__top
      .form__header
        h1.form__title {{ $l10n("COMPLAIN") }}
      .form__body
        label.form__control(
          :class="{ 'has-error': $v.form.name.$invalid }"
        )
          span.form__field
            Input(
              v-model='form.name' 
              :set-focus='true'
              :placeholder='$l10n("YOUR_NAME")'
              name='name'
              type='text'
            )
          span.form__errors(v-if='$v.form.name.$invalid')
            span.form__error(v-if="!$v.form.name.required") {{ $l10n("VALIDATION_REQUIRED_FIELD") }}

        label.form__control(
          :class="{ 'has-error': $v.form.email.$invalid }"
        )
          span.form__field
            Input(
              v-model='form.email' 
              :placeholder='$l10n("YOUR_EMAIL")'
              name='email'
              type='email'
            )
          span.form__errors(v-if='$v.form.email.$invalid')
            span.form__error(v-if="!$v.form.email.required") {{ $l10n("VALIDATION_REQUIRED_FIELD") }}
            span.form__error(v-if="!$v.form.email.email") {{ $l10n("VALIDATION_NOTVALID_EMAIL") }} 


        label.form__control(
          :class="{ 'has-error': $v.form.text.$invalid }"
        )
          .form__field
            Textarea(
              v-model='form.text' 
              :required='true'
              :placeholder='$l10n("COMMENT")'
              name='text'
              type='text'
            )
          span.form__errors(v-if='$v.form.text.$invalid')
            span.form__error(v-if="!$v.form.text.required") {{ $l10n("VALIDATION_REQUIRED_FIELD") }}

      .form__footer
        .form__button
          Button(
            :label='$l10n("SEND")'
            class-list='is-wide'
          )
</template>
<script>
import Button from "@/components/Button/Button";
import Input from "@/components/Input/Input";
import Textarea from "@/components/Textarea/Textarea";

import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "ComplainFormTemplate",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      form: {
        name: "",
        email: "",
        text: ""
      }
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      email: {
        email,
        required
      },
      text: {
        required
      }
    }
  },
  components: { Button, Input, Textarea },
  computed: {
    classList() {
      return {
        "is-dirty": this.$v.$dirty,
        "is-loading": this.loading
      };
    },
    type() {
      try {
        return this.data.type;
      } catch (error) {
        return null;
      }
    },
    id() {
      try {
        return this.data.id;
      } catch (error) {
        return null;
      }
    }
  },
  methods: {
    ...mapActions({
      userComplain: "user/complain"
    }),
    resetError() {
      this.$v.$reset();
    },
    async complain() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.loading = true;

        await this.userComplain({
          name: this.form.name,
          email: this.form.email,
          text: this.form.text,
          type: this.type,
          id: this.id
        });

        this.loading = false;
      }
    }
  }
};
</script>
